import { SET_PARENTS_TREE } from "features/overview-budget/rdx/scenario-details.actions";

const INITIAL_STATE = {
  parentsTree: null,
};

// eslint-disable-next-line default-param-last
const scenarioDetailsReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PARENTS_TREE:
      return {
        ...state,
        parentsTree: new Map([...payload.parentsTree]),
      };
    default:
      return state;
  }
};

export default scenarioDetailsReducer;
